import UserSimulation24 from '@carbon/icons-react/es/user--simulation/24';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { RoutePaths } from 'constant';
import { useTranslate } from 'hooks/use-translation';
import { Header } from './components';
import styles from './group.module.css';

const ResourceRequestHeaderPrimaryBlock = styled(Header.PrimaryBlock)`
  height: fit-content;
  margin-left: var(--spacing-05);
`;

const ResourceRequestHeaderPrimary = styled(Header.Primary)`
  display: flex;
  align-items: center;
`;

export const ResourceRequestHeader = ({ children }) => {
  const translate = useTranslate();

  return (
    <Header className={styles.header}>
      <ResourceRequestHeaderPrimary>
        <UserSimulation24 />
        <ResourceRequestHeaderPrimaryBlock
          title={translate('notifications.resource_request.header')}
          className={`${styles.title} ${styles.ellipsis}`}
        >
          <Link to={`${RoutePaths.resourceRequest}/approver`}>
            {translate('notifications.resource_request.header')}
          </Link>
        </ResourceRequestHeaderPrimaryBlock>
      </ResourceRequestHeaderPrimary>
      <Header.Hanger>{children}</Header.Hanger>
    </Header>
  );
};
